module.exports = __webpack_public_path__ + "img/01-BABO-A-off.b8cbfb4a.png";